export default "/images/near_expiry.png?c524aee9405d88d2f2b3ed8f0368377b";